import { useHotelsStore } from '@/stores/hotels'
import { useVuelidate } from '@vuelidate/core'
import {
	helpers,
	minLength,
	not,
	numeric,
	required,
	requiredIf,
	sameAs,
} from '@vuelidate/validators'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useToast } from 'vue-toastification'

import useAuthUser from '@/composables/useAuthUser'

const useHotelFormValidation = () => {
	const toast = useToast()
	const { user } = useAuthUser()
	const { form } = storeToRefs(useHotelsStore())

	const rules = computed(() => {
		return {
			Start: {
				required: helpers.withMessage(
					'Las fechas de reservación son requeridas.',
					required
				),
			},
			Quantity: {
				required: helpers.withMessage(
					'El número de viajeros es requerido.',
					required
				),
				numeric,
			},
			GuestCount: {
				required: helpers.withMessage(
					'El número de huespedes es requerido',
					required
				),
				numeric,
			},
			IsPerRoom: {
				required: helpers.withMessage(
					'El tipo de habitación es requerido.',
					required
				),
			},
			longitude: {
				required: helpers.withMessage('El destino es requerido.', required),
				not: helpers.withMessage('El destino es requerido.', not(sameAs(0))),
			},
			users: {
				minLength: minLength(1),
				required: helpers.withMessage(
					'Mínimo un viajero es requerido.',
					required
				),
			},
			memberId: {
				requiredIf: helpers.withMessage(
					'El socio es requerido.',
					requiredIf(() => {
						return user.value?.internal === true
					})
				),
			},
		}
	})

	const hotelVuelitate = useVuelidate(rules, form)

	const raiseErrors = () => {
		hotelVuelitate.value.$touch()
		const errors = hotelVuelitate.value.$silentErrors

		console.log(errors)

		errors.forEach((error) => {
			toast.error(error.$message)
		})
	}

	return {
		hotelVuelitate,
		raiseErrors,
	}
}

export default useHotelFormValidation
